import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal } from "./Reveal";
import { FAQS } from "./data";

export const Faq = () => (
    <section id="faq" className="scroll-mt-20 bg-white py-20 lg:py-28" data-testid="faq-section">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
            <Reveal className="text-center">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">FAQ</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="faq-heading">
                    Masih Ragu?{" "}
                    <span className="font-accent italic text-[#123E65]">Cek di Sini.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-12">
                <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem key={f.q} value={`faq-${i + 1}`}
                            className="overflow-hidden rounded-2xl border border-[#071B37]/8 bg-[#F8F6F1] px-6 transition-colors duration-300 data-[state=open]:border-[#DDB56C]/50 data-[state=open]:bg-white"
                            data-testid={`faq-item-${i + 1}`}>
                            <AccordionTrigger className="py-5 text-left hover:no-underline" data-testid={`faq-trigger-${i + 1}`}>
                                <span className="text-base font-bold text-[#1C2533]">{f.q}</span>
                            </AccordionTrigger>
                            <AccordionContent className="pb-6 text-sm leading-relaxed text-[#1C2533]/70 sm:text-base" data-testid={`faq-content-${i + 1}`}>
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
